module.exports = __webpack_public_path__ + "img/ic_add.48cc75df.svg";